// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"180":"7148c2c0","331":"7148c2c0","503":"8b2f1e9a","514":"7148c2c0","522":"8b191abc","615":"7148c2c0","784":"7148c2c0","785":"7148c2c0"}[chunkId] + ".chunk.css";
};